import { type FullAirHandlerUnit } from "@eisox/api/core-api";

/**
 * Accesses a nested property of an object using a property path
 */
const getNestedProperty = <T, P extends Paths<T>>(obj: T, path: P): PathValue<T, P> => {
  const keys = (path as string).split(".");
  let result: unknown = obj;

  for (const key of keys) {
    if (result == null || typeof result !== "object") {
      return undefined as PathValue<T, P>;
    }
    result = (result as Record<string, unknown>)[key];
  }

  return result as PathValue<T, P>;
};

export const checkInconsistencies = <P extends Paths<FullAirHandlerUnit>>(
  referenceAirHandlerUnit: FullAirHandlerUnit,
  airHandlerUnits: FullAirHandlerUnit[],
  property: P,
): {
  property: P;
  value: PathValue<FullAirHandlerUnit, P>;
  inconsistency: Map<string, { inconsistency: boolean; value: PathValue<FullAirHandlerUnit, P>; date?: string }> | null;
} | null => {
  if (airHandlerUnits.length === 0) return null;

  const referenceValue = getNestedProperty(referenceAirHandlerUnit, property);

  const inconsistencies = new Map<
    string,
    { inconsistency: boolean; value: PathValue<FullAirHandlerUnit, P>; date?: string }
  >();
  if (!airHandlerUnits.every(ahu => getNestedProperty(ahu, property) === referenceValue)) {
    airHandlerUnits.forEach(ahu => {
      const value = getNestedProperty(ahu, property);
      const inconsistency = value !== referenceValue;
      inconsistencies.set(ahu.name, { inconsistency, value, date: ahu.lastBmsDataReport });
    });
  }

  return {
    property: property,
    value: referenceValue,
    inconsistency: inconsistencies.size === 0 ? null : inconsistencies,
  };
};
